import 'whatwg-fetch';

import * as constants from '../constants/actions';
import * as endpoint from '../constants/endpoints';
import * as api from '../constants/api';

import {parseJSON,isOk,authReq} from '../utils/request';


/******************************
*******  Synchronous  *********
******************************/




export function authSave(token, tokenExpiry) {
  return {
    type: constants.AUTH_SAVE,
    token,
    tokenExpiry
  };
}

// // Exists outside auth reducer in root reducer
export function authClear() {
	return {
		type: constants.AUTH_CLEAR
	}
}


/******************************
*******  Asynchronous  ********
******************************/

export function authLogin(username, password) {
  return dispatch => {

  	let authData = {
  		username: username,
  		password: password,
  	}

    let url = api.MAGENTO_API + endpoint.MAGENTO_LOGIN;
    return fetch(url, {
      method: 'post',
      headers: api.HEADERS,
      body: JSON.stringify(authData)
    })
    .then(parseJSON)
    .then((resp) => {
      if(isOk(resp.status)) {
        return Promise.resolve(resp.data);
      } else {
        return Promise.reject(resp.data);
      }
    });
  }
}

export function authRegister(registerData) {
  return dispatch => {


    let url = api.MAGENTO_API + endpoint.MAGENTO_REGISTER;
    return fetch(url, {
      method: 'post',
      headers: api.HEADERS,
      body: JSON.stringify(registerData)
    })
    .then(parseJSON)
    .then((resp) => {
      if(isOk(resp.status)) {
        return Promise.resolve(resp.data);
      } else {
        return Promise.reject(resp.data);
      }
    });
  }
}


// WEBPACK FOOTER //
// ./src/actions/auth.jsx